import { createAction, props } from "@ngrx/store";
import { RemarkData } from "../../models/remarkDataModel";

export const fetchRemarksData = createAction(
    '[Admin] Fetch Remark Data'
)

export const updateRemarksData = createAction(
    '[Admin] Update Remark Data',
    props<{ remarksData: RemarkData[] }>()
)

export const deleteRemarksData = createAction(
    '[Admin] Delete Remark Data',
    props<{ id: RemarkData["id"] }>()
)

export const fetchRemarksError = createAction(
    '[Admin] Fetch Remarks Error',
    props<{ error: any }>()
)

export const deleteRemarksError = createAction(
    '[Admin] Delete Remarks Error',
    props<{ error: any }>()
)

export const deleteRemarksSuccess = createAction(
    '[Admin] Delete Remarks Success',
    props<{ id: RemarkData["id"] }>()
)
